export const WASTE_EXCHANGE_TYPE = {
  "CONTAINER_EXCHANGE": "ContainerExchange",
  "LOADING": "Loading"
}

export const WasteExchangeType = {
  "Loading": "Załadunek",
  "ContainerExchange": "Wymiana kontenera",
}

export const WasteExchangeBadges = {
  "ContainerExchange": "teal",
  "Loading": "fiolet"
}